var $ = require('jquery');
require('./web/highslide-settings');
require('./web/jquery.webslider-hp');
//require('./web/jquery.gm');
//require('./web/jquery.gm.conf');
require('./web/plUpload/fg.upload');
require('fg-frontend/ramjet/liveValidation');
require('fg-frontend/ramjet/partialUpdate');
require('./web/MultipleWidgetContainer/index');
require('fg-frontend/third/jquery.cookie');
require('bootstrap/js/dist/modal');


$('.js_back').on('click', function(e) {
  e.preventDefault();
  window.history.back();
});


$('.js_anchors a').on('click', function(e){
  e.preventDefault();
  var targetOffset;
  $('.js_anchors li').removeClass('active');
  $(this).parents('li').addClass('active');
  targetOffset = $($(this).attr('href')).offset();
  if (typeof(targetOffset) !== 'undefined') {
    $('html,body').animate({scrollTop: targetOffset.top},'slow');
  }
});

/**
 * Animovany burger
 */
//menu scroll
$(window).scroll(function(event){
	if ($(this).scrollTop() >= 20) {
		$('.simple-header').addClass('simple-header--scrolled');
	} else {
		$('.simple-header').removeClass('simple-header--scrolled');
	}
	var landingHeight = 0;

	if($('.landing-subpage').length) {
		landingHeight = $('.landing-subpage').outerHeight();
	} else if ($('.landing').length) {
		landingHeight = $('.landing').outerHeight();
	}

	if($(this).scrollTop() >= landingHeight && $(this).scrollTop() <= ($('.career-footer-contact').offset().top - $('.aside-contact-us').outerHeight() - 200)) {
		$('.aside-contact-us').addClass('aside-contact-us--show');
		$('.aside-contact-us').removeClass('aside-contact-us--hide');
	} else {
		$('.aside-contact-us').addClass('aside-contact-us--hide');
		$('.aside-contact-us').removeClass('aside-contact-us--show');
	}
});

//mobile menu

$('.simple-header__hamburger, .simple-header__menu-backdrop, .simple-header__close').on('click', function(){
	$('.simple-header').toggleClass('simple-header--opened');
});

//scroll to
$('.js_scroll-to').on('click', function(e){
	e.preventDefault();
	var el = $($(this).attr('href'));
	var offset = $('.simple-header__container').outerHeight() + 10;
	var top = el.offset().top - offset;
	$('html, body').stop().animate({
		scrollTop: top
	}, 1000);
});

//scroll to top
$('.js_scroll-to-top').on('click', function(e){
	e.preventDefault();
	$("html, body").animate({ scrollTop: 0 }, "slow");
});

// RWD tables
$('table.table').each(function() {
    $(this).wrap('<div class="table-responsive"></div>');
});


$('.map-filter__box').on('mouseover', function(e) {
	$(this).addClass('hover');
});

$('.map-filter__box').on('mouseleave', function(e) {
	$(this).removeClass('hover');
});

$('.aside-contact-us__icon-close').on('click', function(e) {
	e.preventDefault();
	$('.aside-contact-us').hide();
});

$('.js_show-modal-video').on('click', function(e) {
   e.preventDefault();
   $('#video .embed-responsive-item').attr('src', $(this).attr('data-url'));
});

$('.modal__close').on('click', function(e) {
	$('#video .embed-responsive-item').attr('src', '');
});


/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
$.each(q, function(index, f) {
    $(f);
});



// WEBPACK FOOTER //
// ./fe/web-career/src/js/web.js